exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3wWXv {\n  height: 379px;\n  overflow: auto;\n}\n._5qsK8 {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-top: 1px solid #aaa;\n  text-align: center;\n  padding: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_3wWXv",
	"button": "_5qsK8"
};